import { useEffect, useState } from 'react';
import { routeAliases, routes, supportedRoutes } from '../routes/routes';

export function getCurrentHashPath() {
  const rawHash = window.location.hash.replace(/^#/, '');
  const rawPath = rawHash.split('?')[0] || routes.home;
  const normalizedPath = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
  const resolvedPath = routeAliases[normalizedPath] || normalizedPath;

  return supportedRoutes.has(resolvedPath) ? resolvedPath : routes.home;
}

export function useHashPath() {
  const [path, setPath] = useState(getCurrentHashPath);

  useEffect(() => {
    const handleHashChange = () => setPath(getCurrentHashPath());

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return path;
}
